import React from 'react';
import { useTealiumView } from 'modules/accounts';
import { NavigationTabLink } from 'modules/ui';

export default function SettingsTabs() {
  useTealiumView('Settings Page');
  return (
    <>
      <NavigationTabLink end to="/settings/change-password">
        Change Password
      </NavigationTabLink>
      <NavigationTabLink end to="/settings/change-email">
        Change Email
      </NavigationTabLink>
      <NavigationTabLink end to="/settings/delete-account">
        Delete Account
      </NavigationTabLink>
    </>
  );
}
